import { IAttachment } from '~/client/graph'
import { PropertyType } from '~/client/graph/types.generated'

import { IResourceRecord } from '../../resources/definitions/types'
import { IResourceProperty } from '../ResourceCardList/types'

/**
 * Collects every attachment from every File-typed property on a resource
 * record, in property order. Used to surface attachments below the resource
 * row inside the picker.
 */
export function getResourceAttachments(
  record: IResourceRecord,
  properties: IResourceProperty[],
): IAttachment[] {
  if (!record?.data || !properties?.length) return []

  const result: IAttachment[] = []
  for (const property of properties) {
    if (property.propertyType !== PropertyType.File) continue
    const raw = record.data[property.name]
    const value = Array.isArray(raw) ? raw : raw ? [raw] : []
    for (const item of value) {
      if (item && typeof item === 'object' && 'url' in item) {
        result.push(item as IAttachment)
      }
    }
  }
  return result
}
